module.exports = "<div class=bc-block-list-colors-standard ng-transclude=slotContent></div>";